import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSelector } from '../../../table/state/selector'
import { APPOINTMENT_TABLE } from './type'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectTable = createTableSelector(selectOwnState, APPOINTMENT_TABLE)


export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}



// WEBPACK FOOTER //
// ./src/modules/appointment/state/search/selector.js